export default __webpack_public_path__ + "static/media/required-gold-ico.49b31059.svg";